import {RouterModule, Routes} from '@angular/router';
import {CampusListComponent} from './pages/campus-list/campus-list.component';
import {EditCampusComponent} from './pages/edit-campus/edit-campus.component';
import {SiteComponent} from './pages/site/site.component';

export let routes: Routes = [
  {
    path: '',
    component: CampusListComponent,
  },
  {
    path: 'campus/:id',
    component: EditCampusComponent,
  },
  {
    path: 'site',
    component: SiteComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

export let AppRoutesModule = RouterModule.forRoot(routes);
